import styled, { css } from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${spacing[3]} ${spacing[4]};
  border-top: 1px solid ${rawColors.stroke[200]};
  background-color: ${rawColors.structural.white};
`;

export const Group = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[3]};
`;

export const PageSizeSelect = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[6]};
  height: 38px;
  padding: 0 ${spacing[4]};
  background-color: ${rawColors.structural.white};
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.md};
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.highEmphasis};
  cursor: pointer;

  &:disabled {
    cursor: default;
  }
`;

export const PageSizeNativeSelect = styled.select`
  appearance: none;
  height: 38px;
  padding: 0 ${spacing[10]} 0 ${spacing[4]};
  background-color: ${rawColors.structural.white};
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%23475569' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right ${spacing[4]} center;
  border: 1px solid ${rawColors.stroke[300]};
  border-radius: ${borderRadius.md};
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.highEmphasis};
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: ${rawColors.primary[300]};
    box-shadow: 0 0 0 2px ${rawColors.primary[100]};
  }

  option {
    background-color: ${rawColors.structural.white};
    color: ${rawColors.text.highEmphasis};
  }

  option:checked {
    background-color: ${rawColors.primary[100]};
    color: ${rawColors.text.highEmphasis};
  }
`;

export const RangeLabel = styled.span`
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.mediumEmphasis};
`;

export const PageNumber = styled.span<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  ${typographyMixin("body", 2)}
  text-align: center;
  color: ${rawColors.text.highEmphasis};
  border-radius: ${borderRadius.md};
  ${({ $active }) =>
    $active &&
    css`
      border: 1px solid ${rawColors.primary[500]};
    `}
`;

export const PageOf = styled.span`
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.mediumEmphasis};
`;

export const PagerIcon = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  color: ${rawColors.text.mediumEmphasis};
  cursor: pointer;
  padding: ${spacing[1]};
  border-radius: ${borderRadius.sm};

  &:hover:not(:disabled) {
    color: ${rawColors.text.highEmphasis};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;
